import axios from "~/plugins/axios";

export default {
  paginateByMortgage(mortgageId, page = 1, perPage = 20, includes = []) {
    return axios.get(`/web_api/v1/mortgage_property/by_mortgage/${mortgageId}`, {
      params: {
        page,
        perPage,
        include: includes,
      },
    }).then((response) => response.data);
  },
  paginateByProperty(propertyId, page = 1, perPage = 20, includes = []) {
    return axios.get(`/web_api/v1/mortgage_property/by_property/${propertyId}`, {
      params: {
        page,
        perPage,
        includes,
      },
    }).then((response) => response.data);
  },
  findByMortgageAndProperty(mortgageId, propertyId) {
    return axios.post("/web_api/v1/mortgage_property/by_mortgage_and_property", {
      mortgage_id: mortgageId,
      property_id: propertyId,
    }).then((response) => response.data);
  },
  create(mortgageProperty) {
    return axios.post("/web_api/v1/mortgage_property", mortgageProperty).then((response) => response.data);
  },
  update(mortgageProperty) {
    return axios.put(`/web_api/v1/mortgage_property/${mortgageProperty.id}`, mortgageProperty).then((response) => response.data);
  },
  delete(mortgagePropertyId) {
    return axios.delete(`/web_api/v1/mortgage_property/${mortgagePropertyId}`).then((response) => response.data);
  },
  createByMortgageAndProperty(mortgageId, propertyId) {
    return axios.post("/web_api/v1/mortgage_property", {
      mortgage_id: mortgageId,
      property_id: propertyId,
    }).then((response) => response.data);
  },
  findById(mortgagePropertyId, include = []) {
    return axios.get(`/web_api/v1/mortgage_property/${mortgagePropertyId}`, {
      params: {
        include,
      },
    }).then((response) => response.data);
  },
  findByProperty(propertyId, include = []) {
    return axios.get(`/web_api/v1/mortgage_property/by_property/${propertyId}`, {
      params: {
        include,
      },
    }).then((response) => response.data);
  },
  findByPropertyForCustomer(propertyId, customerId, include = []) {
    return axios.get(`/web_api/v1/mortgage_property/by_property/${propertyId}/for_customer/${customerId}`, {
      params: {
        include,
      },
    }).then((response) => response.data);
  },
};
